import { TARGET_URL } from '../../const';

export const updateTargetURLCookie = () => {
  const utmFromStorage = localStorage.getItem(TARGET_URL);

  const referrer = document.referrer;

  const { host, href } = window.location;

  const referrerHost = referrer && new URL(referrer).host;
  const isGoogleHost = referrerHost.includes('google');

  const isUtmSourceInUrl = href.includes('utm_source');
  const isNdlInUtm = href.includes(`&ndl`) || !!utmFromStorage?.includes('&ndl');

  const isTargetUrlFromLocalStore = localStorage.getItem('target_url');

  const utm_source =
    utmFromStorage && decodeURIComponent(utmFromStorage)?.split('utm_source=')[1]?.split('&')[0];

  const isCase0 = isUtmSourceInUrl;

  const isCase1 = !isUtmSourceInUrl && (isGoogleHost || !!utmFromStorage?.includes('google'));

  const isCase2 =
    !isUtmSourceInUrl &&
    !!referrer &&
    ((!utmFromStorage && !isGoogleHost) || (!!utmFromStorage && !utm_source?.includes('google')));

  const isCase3 =
    !isUtmSourceInUrl &&
    (!referrer ||
      referrer.includes(`undefined`) ||
      referrer.includes(`lendplus.in`) ||
      referrer.includes(`${host}`));

  localStorage.setItem('utm_set_target_url_delay', 'true');

  if (
    localStorage.getItem('utm_set_target_url_delay') === 'true' &&
    !isNdlInUtm &&
    !isTargetUrlFromLocalStore
  ) {
    switch (true) {
      case isCase0:
        return localStorage.setItem('target_url', href);

      case isCase1:
        return localStorage.setItem(
          'target_url',
          `https://${host}/?utm_source=google&utm_medium=organic&utm_campaign=organic`
        );

      case isCase2:
        return localStorage.setItem(
          'target_url',
          `https://${host}/?utm_source=referral&utm_medium=referral&utm_campaign=${referrerHost}`
        );

      case isCase3:
        return localStorage.setItem(
          'target_url',
          `https://${host}/?utm_source=direct&utm_medium=none&utm_campaign=direct`
        );
    }
  }
};
